<script setup lang="ts">
    import useBuefy from '@/shared/composables/useBuefy';
    import useShow from '@/shared/composables/useShow';
    import { deleteShippingPackage } from '@/shared/helpers/api';
    import { http } from '@/shared/httpWrapper';
    import { useShippingStore } from '@/stores/shippingStore';

    const store = useShippingStore();
    const buefy = useBuefy();
    const { showError } = useShow();

    async function onDelete(): Promise<void> {
        buefy.dialog.confirm({
            title: 'Please confirm',
            message: 'Are you sure you want to permanently delete this package?',
            type: 'is-danger',
            hasIcon: true,
            cancelText: 'No',
            confirmText: 'Yes',
            onConfirm: async () => {
                const loadingComponent = buefy.loading.open({});
                try {
                    await deleteShippingPackage(http, store.selectedPackage!.packageId);
                    await store.clearSelectedPackage();
                    store.init();
                } catch (err) {
                    showError(err);
                } finally {
                    loadingComponent.close();
                }
            }
        });
    }
</script>

<template>
    <b-button
        icon-left="delete"
        type="is-danger"
        @click="onDelete">
        Delete
    </b-button>
</template>
